"use strict";

exports.__esModule = true;
exports.estimateLabelWidth = estimateLabelWidth;
exports.fitLabel = fitLabel;
var _guessRelativeTextSize = require("./guessRelativeTextSize");
// Uppercase, letter-spaced labels come out about this wide per unit of
// guessRelativeTextSize at a given font size.
var UPPERCASE_WIDTH_FACTOR = 0.78;

/**
 * Estimate the rendered width of an uppercase label in pixels.
 */
function estimateLabelWidth(text, fontSize) {
  return Math.ceil((0, _guessRelativeTextSize.guessRelativeTextSize)(text) * fontSize * UPPERCASE_WIDTH_FACTOR);
}

/**
 * Shorten an uppercase label with an ellipsis so it fits the given width.
 */
function fitLabel(text, fontSize, maxWidth) {
  if (!text || estimateLabelWidth(text, fontSize) <= maxWidth) {
    return text;
  }
  var perChar = fontSize * UPPERCASE_WIDTH_FACTOR;
  var chars = Math.max(2, Math.floor(maxWidth / perChar) - 1);
  return text.slice(0, chars).trimEnd() + "\u2026";
}